/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ name: NonNullable<unknown> }} Agent_Builder_Spaces_RemoveInputs */



/**
* | output |
* | --- |
* | "Remove {name}" |
*
* @param {Agent_Builder_Spaces_RemoveInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const agent_builder_spaces_remove = /** @type {((inputs: Agent_Builder_Spaces_RemoveInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Agent_Builder_Spaces_RemoveInputs, { locale?: "en" | "de" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ (`${i?.name} entfernen`)
	return /** @type {LocalizedString} */ (`Remove ${i?.name}`)
});